import { Box, Spinner, SpinnerProps } from '@amzn/awsui-components-core';
import React from 'react';

interface Props {
  size?: SpinnerProps.Size;
}

const LoadingIndicator: React.FC<Props> = ({ size = 'normal' }) => {
  return (
    <Box textAlign="center">
      <Spinner size={size} />
    </Box>
  );
};

export default LoadingIndicator;
